import React from "react";

export default function About() {
  return (
    <div className="about container split">
      <div className="about-text">
        <h3>O FIRMIE</h3>
        <p>
          Jesteśmy firmą specjalizującą się w serwisie drzwi automatycznych.
          Zapewniamy fachowy serwis, niezawodne rozwiązania oraz szybką reakcję
          24 godziny na dobę, 7 dni w tygodniu.
        </p>
      </div>

      <div className="about-image">
        {/* PLACEHOLDER: wklej tutaj swoje zdjęcie lub <img src="..." alt="drzwi" /> */}
      </div>
    </div>
  );
}
